module.exports = __webpack_public_path__ + "fonts/athletes-2m-ic.svg";